<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-alert color="gifty" text border="top" v-if="can('admin | client')">
          <div class="d-flex align-center justify-space-between">
            <div>
              Veuillez choisir une campagne pour visualiser les données filtrées.
            </div>
            <div :style="{width: '400px'}">
              <v-autocomplete placeholder="Sélectionner une campagne..."
                              :loading="isLoading"
                              :items="campaigns"
                              color="gifty"
                              v-model="opus_campaign_id"
                              item-value="id"
                              hide-details
                              item-text="name.fr"></v-autocomplete>
            </div>
          </div>
        </v-alert>

        <div class="text-end mb-3">
          <v-btn color="gifty" text @click="handleExport"
                 v-if="can('admin | client')"
                 :disabled="!opus_campaign_id">
            <v-icon left>mdi-export</v-icon>
            Exporter
          </v-btn>
          <v-btn color="gifty" dark depressed @click="refresh">
            <v-icon left>mdi-refresh</v-icon>
            Mettre à jour
          </v-btn>
        </div>

        <WidgetCards ref="ref1" :opus_campaign_id="opus_campaign_id"/>
        <v-row>
          <v-col cols="12">
            <ParticipationByWilaya ref="ref2" :opus_campaign_id="opus_campaign_id"/>
          </v-col>
          <v-col cols="12">
            <PointsByWilaya ref="ref3" :opus_campaign_id="opus_campaign_id"/>
          </v-col>

          <v-col cols="12">
            <ComplianceByWilaya ref="ref4" :opus_campaign_id="opus_campaign_id"/>
          </v-col>
          <v-col cols="12">
            <TasksCompleted ref="ref5" :opus_campaign_id="opus_campaign_id"/>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import WidgetCards from "@/views/opus/dashboard/components/WidgetCards";
import ParticipationByWilaya from "@/views/opus/dashboard/components/ParticipationByWilaya";
import PointsByWilaya from "@/views/opus/dashboard/components/PointsByWilaya";
import ComplianceByWilaya from "@/views/opus/dashboard/components/ComplianceByWilaya";
import TasksCompleted from "@/views/opus/dashboard/components/TasksCompleted";

export default {
  components: {PointsByWilaya, ComplianceByWilaya, ParticipationByWilaya, WidgetCards, TasksCompleted},
  data() {
    return {
      campaigns: [],
      opus_campaign_id: null,
      isLoading: false
    }
  },
  methods: {
    refresh() {
      this.$refs.ref1.getWidgets()
      this.$refs.ref2.participationByWilaya()
      this.$refs.ref3.pointsByWilaya()
      this.$refs.ref4.complianceByWilaya()
      this.$refs.ref5.getCompletedInvestigations()
    },
    handleExport() {
      let baseUrl = process.env.VUE_APP_FILE_URL;
      let token = this.$store.state.user.access_token;
      let userId = this.$store.state.user.user.id;
      let url = baseUrl + "/api/v1/opus/campaigns/export?token=" + token + "&user_id=" + userId + "&campaign_id=" + this.opus_campaign_id;
      url += "&filter=" + encodeURIComponent(JSON.stringify(this.filter));
      window.open(url, '_blanc')
    },
    fetchOpusCampaigns() {
      this.isLoading = true
      HTTP.get('/v1/opus/campaigns/all').then(res => {
        this.campaigns = res.data.data
        this.opus_campaign_id = this.campaigns && this.campaigns.length ? this.campaigns[0].id : null
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.fetchOpusCampaigns()
  },
};
</script>

<style scoped>
</style>
